<ng-container *ngIf="state$ | async as state">
  <mat-card class="p-25 m-t-25">
    <div fxLayout="row wrap" fxLayout.xs="column">
      <div
        fxFlex="60%"
        fxFlex.sm="60%"
        ngClass.gt-sm="border-right-separator p-r-25"
      >
        <div fxLayout="row" fxLayout.xs="column">
          <div ngClass.gt-sm="p-r-25" fxFlex="60%">
            <label class="font-bold">Tipo de Información</label>
            <lib-form-control
              appearance="outline"
              variant="select"
              bindLabel="label"
              bindValue="name"
              [formGroupParent]="form"
              placeholder="Seleccione"
              controlName="tipoInformacion"
              [options]="tiposInformacion"
            >
            </lib-form-control>
          </div>

          <div
            fxFlex="40%"
            *ngIf="form.get('tipoInformacion').value != 'INSTITUCIONAL'"
          >
            <label class="font-bold">Periodo académico</label>
            <lib-form-control
              appearance="outline"
              variant="select"
              bindLabel="label"
              bindValue="name"
              [formGroupParent]="form"
              placeholder="Seleccione"
              controlName="idPeriodo"
              [options]="tiposPeriodos"
            >
            </lib-form-control>
          </div>
        </div>

        <div class="display-flex-center">
          <button
            mat-flat-button
            class="rounded-full bg-naranja-sunedu"
            (click)="handleClickDescargarFicha()"
          >
            Descargar ficha técnica
          </button>
          <span class="flex-spacer"></span>
          <span class="font-bold" *ngIf="fechaCorte$ | async as fechaCorte">
            Fecha de corte: {{ fechaCorte | dateFormat : "" : "DD/MM/YYYY" }}
          </span>
        </div>
        <lib-grid
          variant="list"
          class="sunedu-grid-blue"
          [loading]="state.gridInformacionDetallada.loading"
          [definition]="state.gridInformacionDetallada.definition"
          [source]="state.gridInformacionDetallada.source"
        >
          <ng-template libTemplate="tpl-descarga" let-item>
            <button
              *ngFor="let formato of item.formatos"
              class="tuni-icon-button"
              (click)="downloadFormat(formato, item)"
            >
              <span
                matTooltip="{{ formato.formato }}"
                (mouseover)="itemHover($event, true, formato)"
                (mouseout)="itemHover($event, false, formato)"
                [ngClass]="getIconDownload(formato)"
              ></span>
            </button>
            <mat-spinner
              *ngIf="getIsDownloaded(item.formatos)"
              class="spinner-download"
              [diameter]="25"
            ></mat-spinner>
          </ng-template>
        </lib-grid>

        <div class="textoInfoUniversidad m-t-20" style="text-align: justify">
          <span class="font-bold">Nota:</span>
          Los datos presentados corresponden a universidades licenciadas que
          reportaron su información correctamente en el Sistema de Información
          Universitaria (SIU) hasta el {{state.gridFechaCorte.diaMesAnio}}. Cabe precisar que la
          información de docentes del periodo 2024-II, a la fecha de corte
          señalada, es parcial. Para el caso de oferta universitaria, la
          información se encuentra actualizada hasta el {{state.gridInstFechaCorte.diaMesAnio}}.
        </div>
      </div>
      <div
        fxLayout="column wrap"
        class="container-tab-informacion-api"
        ngClass.gt-sm="p-l-20"
        ngClass.lt-md="m-t-25"
        fxFlex="40%"
        fxFlex.sm="40%"
      >
        <div class="container-tab-informacion-api-top">
          <h3>¿Qué es una API?</h3>
          <p style="text-align: justify">
            La interfaz de programación de aplicaciones, conocida también por la
            sigla API, en inglés, application programming interface, es un
            conjunto de subrutinas, funciones y procedimientos (o métodos, en la
            programación orientada a objetos) que ofrece cierta biblioteca para
            ser utilizada por otro software como una capa de abstracción.
          </p>
        </div>
        <div class="container-tab-informacion-api-down m-t-10">
          <h3>¿Cómo funciona?</h3>
          <div fxLayout="row wrap">
            <div fxFlex="auto" class="text-center">
              <img
                (click)="handleSolicitaApi()"
                height="120"
                [src]="solicitaApiButton.src || solicitaApiButton.srcOut"
                (mouseover)="solicitaApiButton.src = solicitaApiButton.srcOn"
                (mouseout)="solicitaApiButton.src = solicitaApiButton.srcOut"
              />
            </div>
            <div fxFlex="auto" class="text-center">
              <img
                (click)="handleBuscaKey()"
                height="120"
                [src]="buscaApiButton.src || buscaApiButton.srcOut"
                (mouseover)="buscaApiButton.src = buscaApiButton.srcOn"
                (mouseout)="buscaApiButton.src = buscaApiButton.srcOut"
              />
            </div>
          </div>
          <div fxLayout="row wrap">
            <div fxFlex="auto" class="text-center">
              <img
                (click)="handleEncuestaApi()"
                height="120"
                [src]="encuestaApiButton.src || encuestaApiButton.srcOut"
                (mouseover)="encuestaApiButton.src = encuestaApiButton.srcOn"
                (mouseout)="encuestaApiButton.src = encuestaApiButton.srcOut"
              />
            </div>
            <div fxFlex="auto" class="text-center">
              <img
                (click)="handleManualApi()"
                height="120"
                [src]="manualApiButton.src || manualApiButton.srcOut"
                (mouseover)="manualApiButton.src = manualApiButton.srcOn"
                (mouseout)="manualApiButton.src = manualApiButton.srcOut"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</ng-container>
